import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=4cc1b3f0&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=4cc1b3f0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc1b3f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cc1b3f0')) {
      api.createRecord('4cc1b3f0', component.options)
    } else {
      api.reload('4cc1b3f0', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=4cc1b3f0&scoped=true&", function () {
      api.rerender('4cc1b3f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/tpm/views/budget/extra_cost/form/detail.vue"
export default component.exports